import { Ref } from "react";

// eslint-disable-next-line no-restricted-imports
import { SerializedStyles } from "@emotion/react";

import CrossIcon from "@atlaskit/icon/glyph/cross";

import { useMessages } from "../state";

import { closeModalButtonStyles } from "./close-modal-button.styles";

export const CloseModalButton = ({
    forwardRef,
    onCloseClick,
    styleOverrides
}: {
    forwardRef?: Ref<HTMLButtonElement>;
    onCloseClick: () => void | Promise<void>;
    styleOverrides?: SerializedStyles;
}) => {
    const [messages] = useMessages();

    return (
        <button
            data-testid="closeModalBtn"
            aria-label={messages.createIssueModalCloseBtn}
            css={[styleOverrides, closeModalButtonStyles]}
            id="createIssueModalCloseBtn"
            onClick={onCloseClick}
            ref={forwardRef}
        >
            <CrossIcon label="" size="medium" />
        </button>
    );
};
